export const state = {
  isAuthenticated: false,
  user: null,
  error: null,
  loading: false,
  registrationInfo: null,
  accountInfo: null,
  isAuthorized: false,
  merchant: null
}
